module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "navigace"
    }
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSaveAndQuit && _vm.showNext),
      expression: "!showSaveAndQuit && showNext"
    }],
    staticClass: "button pull-right",
    class: {
      disabled: _vm.disableNext
    },
    on: {
      "click": function($event) {
        _vm.onClickNext()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Continue')) + "\n        ")]), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.showSaveAndQuit && _vm.showPrev),
      expression: "!showSaveAndQuit && showPrev"
    }],
    staticClass: "pull-left",
    class: {
      disabled: _vm.disablePrev
    },
    on: {
      "click": function($event) {
        _vm.onClickPrev()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Previous')) + "\n        ")]), _vm._v(" "), (_vm.showSaveAndQuit) ? _c('a', {
    staticClass: "button pull-right",
    on: {
      "click": _vm.onClickSaveAndQuit
    }
  }, [_vm._v("\n            " + _vm._s(_vm._f("translate")('Save and quit')) + "\n        ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9b461ff8","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigace.vue
// module id = 554
// module chunks = 1